import { defaultApiState } from '../api.state';

export const advisorSettlementMutations = {
  GET_ADVISOR_SETTLEMENTS_LOADING(state) {
    state.apiState.getAdvisorSettlements = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_ADVISOR_SETTLEMENTS_SUCCESS(state, payload) {
    state.apiState.getAdvisorSettlements = {
      ...defaultApiState,
      success: true,
    };
    state.advisorSettlements = payload;
  },
  GET_ADVISOR_SETTLEMENTS_ERROR(state, error) {
    state.apiState.getAdvisorSettlements = {
      ...defaultApiState,
      error,
    };
  },
  GET_ADVISOR_SETTLEMENT_LOADING(state) {
    state.apiState.getAdvisorSettlement = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_ADVISOR_SETTLEMENT_SUCCESS(state, payload) {
    state.apiState.getAdvisorSettlement = {
      ...defaultApiState,
      success: true,
    };
    state.advisorSettlement = payload;
  },
  GET_ADVISOR_SETTLEMENT_ERROR(state, error) {
    state.apiState.getAdvisorSettlement = {
      ...defaultApiState,
      error,
    };
  },
  UPDATE_ADVISOR_SETTLEMENT_LOADING(state) {
    state.apiState.updateAdvisorSettlement = {
      ...defaultApiState,
      loading: true,
    };
  },
  UPDATE_ADVISOR_SETTLEMENT_SUCCESS(state, payload) {
    state.apiState.updateAdvisorSettlement = {
      ...defaultApiState,
      success: true,
    };
    state.advisorSettlement = payload;
  },
  UPDATE_ADVISOR_SETTLEMENT_ERROR(state, error) {
    state.apiState.updateAdvisorSettlement = {
      ...defaultApiState,
      error,
    };
  },
};
